import { CadorReference } from './cador-reference';
import { CareerApplicantAcademicBackground } from './career-applicant-academic-background';
import { CareerApplicantProfessionalBackground } from './career-applicant-professional-background';
import { LevelOfFrench } from './level-of-french';

export class CareerApplicant {

    levelOfEducation: CadorReference;

    levelOfFrench: LevelOfFrench;


    // public yearsOfSchooling: number;

    academicBackgrounds: CareerApplicantAcademicBackground[] = [];

    professionalBackgrounds: CareerApplicantProfessionalBackground[] = [];

    // public allowContactCurrentEmployer: boolean;

}
